import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS

const Dashboard = ({ setIsAuthenticated }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      navigate("/login"); // Redirect to login if not authenticated
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    setIsAuthenticated(false);
    navigate("/login");
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-gradient">
      <div className="bg-white p-5 rounded-4 shadow-lg text-center">
        <h2 className="mb-4 fw-bold text-dark">Select a Page</h2>

        <div className="d-flex gap-3 justify-content-center">
          <button
            onClick={() => navigate("/Inventory")}
            className="btn btn-primary px-4 py-2 fw-bold shadow-sm"
          >
            Inventory
          </button>

          <button
            onClick={() => navigate("/Receiving")}
            className="btn btn-success px-4 py-2 fw-bold shadow-sm"
          >
            Receiving
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
